import React from 'react';
import SvgIcon from '@home/components/SvgIcon';
import NewMarkIcon from '@home/components/NewMarkIcon';
import TipContext from '@home/components/TipContextComponents/TipContext';
import PCConsoleMetricsTable from '@intelligence/pages/TopCharts/PCConsoleGames/MetricsTable';
import PCConsoleDataBrainCalibration from '@intelligence/pages/TopCharts/PCConsoleGames/DataBrainCalibration';
import AlineaAnalyticsCalibration from '@intelligence/v3/pages/TopCharts/PCConsoleGames/AlineaAnalyticsCalibration';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';

const ALINEA_NEW_MARK_EXPIRE_TIME = new Date('2026-10-08T23:59:59+08:00').getTime();

export interface PCConsoleTopChartsVariant {
  id: string;
  labelId: string;
  renderLabel?: (formatMessage: (descriptor: { id: string }) => string) => React.ReactNode;
  Component: React.FC;
}

export const PC_CONSOLE_TOP_CHARTS_VARIANTS: PCConsoleTopChartsVariant[] = [
  {
    id: 'MetricsTable',
    labelId: 'dbi_metrics_table',
    Component: PCConsoleMetricsTable,
  },
  {
    id: 'DataBrainCalibration',
    labelId: 'dbi_dataBrain_calibration',
    renderLabel: (formatMessage) => (
      <div className="dbi-tab-title">
        <SvgIcon className="dbi-tab-title-icon" type="new-logo" />
        <span className="dbi-tab-title-text">{formatMessage({ id: 'dbi_dataBrain_calibration' })}</span>
        <TipContext
          AWidth={600}
          className="dbi-tab-title-tip"
          placement="bottom"
          tipText={formatMessage({ id: 'dbi_pc_console_metrics_table_intro' })}
        />
      </div>
    ),
    Component: PCConsoleDataBrainCalibration,
  },
  {
    id: 'AlineaAnalyticsCalibration',
    labelId: 'dbi_alinea_analytics_calibration',
    renderLabel: (formatMessage) => {
      const showNewMark = Date.now() <= ALINEA_NEW_MARK_EXPIRE_TIME;
      return (
        <div className="dbi-tab-title">
          <img className="dbi-tab-title-icon-img" src={getDataSourceIcon('alinea')} alt="Alinea" />
          <span className="dbi-tab-title-text">{formatMessage({ id: 'dbi_alinea_analytics_calibration' })}</span>
          {showNewMark && <NewMarkIcon className="dbi-tab-title-new-mark" />}
        </div>
      );
    },
    Component: AlineaAnalyticsCalibration,
  },
];

export const PC_CONSOLE_TOP_CHARTS_VARIANT_IDS = PC_CONSOLE_TOP_CHARTS_VARIANTS.map((variant) => variant.id);
